module.exports = __webpack_public_path__ + "img/avatar-null.8fa29ba8.svg";